/**
 * Extrae el slug de local desde el pathname de la Carta (CRA, sin router).
 *
 * /543 → "543"
 * /entregallos → "entregallos"
 * /entregallos/ → "entregallos"
 * / → null
 *
 * El primer segmento no vacío es el slug. No hay if por cliente.
 */

const SLUG_FORMATO = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/**
 * @param {string} [raw]
 * @returns {string|null}
 */
export function normalizarSlug(raw) {
  const slug = String(raw || "")
    .trim()
    .replace(/^\/+|\/+$/g, "")
    .toLowerCase();

  if (!slug || !SLUG_FORMATO.test(slug)) {
    return null;
  }

  return slug;
}

/**
 * @param {string} [pathname]
 * @returns {string|null}
 */
export function resolveSlugFromPathname(pathname) {
  const segmentos = String(pathname || "")
    .split("/")
    .map((s) => s.trim())
    .filter(Boolean);

  if (segmentos.length === 0) {
    return null;
  }

  return normalizarSlug(segmentos[0]);
}

/**
 * @returns {string|null}
 */
export function resolveSlugFromUrl() {
  if (typeof window === "undefined") {
    return null;
  }
  return resolveSlugFromPathname(window.location.pathname);
}
